import { render, staticRenderFns } from "./UsersStaff.vue?vue&type=template&id=746a5ddc&"
import script from "./UsersStaff.vue?vue&type=script&lang=js&"
export * from "./UsersStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports